import { render, staticRenderFns } from "./changeBaseInfo.vue?vue&type=template&id=1045c258&scoped=true&"
import script from "./changeBaseInfo.vue?vue&type=script&lang=js&"
export * from "./changeBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeBaseInfo.vue?vue&type=style&index=0&id=1045c258&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045c258",
  null
  
)

export default component.exports